export var ContextGLProgramType;
(function (ContextGLProgramType) {
    ContextGLProgramType[ContextGLProgramType["FRAGMENT"] = 0] = "FRAGMENT";
    ContextGLProgramType[ContextGLProgramType["SAMPLER"] = 1] = "SAMPLER";
    ContextGLProgramType[ContextGLProgramType["VERTEX"] = 2] = "VERTEX";
})(ContextGLProgramType || (ContextGLProgramType = {}));
